export default "/assets/no_analytics-0ac737df74fbbfe7a0f241f8d7e6ef193daa52aa052e7653092b90e6524ca078.svg";